import { getChatStateRpc, screenshotRpc, storeChatStateRpc } from 'feature-unboxing-client-types/MicroappProductBridgesService-v1/operations';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
export const noAuthRpcClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});
export const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export function generateScreenshot(url) {
  return noAuthRpcClient.call(screenshotRpc, {
    pathParameters: {
      domain: url
    },
    data: {
      imgHeight: 1024,
      imgWidth: 1024
    }
  });
}
export function storeState(data) {
  return noAuthRpcClient.call(storeChatStateRpc, {
    data
  });
}
export function getState(stateId) {
  return rpcClient.call(getChatStateRpc, {
    pathParameters: {
      stateId
    }
  });
}